import { ALL_TEAMS } from './AllTeams'

const makeTeam = (id) => ({
	id,
	name: ALL_TEAMS[id].name,
	slug: ALL_TEAMS[id].slug,
	points: 0,
	playedMatches: 0,
	wonMatches: 0,
	drawnMatches: 0,
	lostMatches: 0,
	goalsFor: 0,
	goalsAgainst: 0,
	goalsDifference: 0,
})

const makeGroup = (ids) =>
	ids.reduce((acc, id) => {
		acc[id] = makeTeam(id)
		return acc
	}, {})

// A-L según TU EXCEL
const A = makeGroup(['MEX', 'RSA', 'KOR', 'RCE'])
const B = makeGroup(['CAN', 'BOS', 'QAT', 'SUI'])
const C = makeGroup(['BRA', 'MAR', 'HAI', 'SCO'])
const D = makeGroup(['USA', 'PAR', 'AUS', 'TUR'])
const E = makeGroup(['GER', 'CUW', 'CIV', 'ECU'])
const F = makeGroup(['NED', 'JPN', 'SWE', 'TUN'])
const G = makeGroup(['BEL', 'EGY', 'IRN', 'NZL'])
const H = makeGroup(['ESP', 'CPV', 'KSA', 'URU'])
const I = makeGroup(['FRA', 'SEN', 'IRQ', 'NOR'])
const J = makeGroup(['ARG', 'ALG', 'AUT', 'JOR'])
const K = makeGroup(['POR', 'RDC', 'UZB', 'COL'])
const L = makeGroup(['ENG', 'CRO', 'GHA', 'PAN'])

export const teamsByGroup = { A, B, C, D, E, F, G, H, I, J, K, L }
